import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import bakingCcpService from '../services/bakingCcpService';

// Ported verbatim from the old Navbar.js (lines 178-210): tracks whether a baking
// production run is currently active, so the pinned Start/Stop Production button
// can swap between "Start Production" and "Production in Progress".
export default function useActiveProductionRun(canProduction) {
  const location = useLocation();
  const [activeRunId, setActiveRunId] = useState(null);
  const [checkingActiveRun, setCheckingActiveRun] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchActiveRun = async () => {
      if (!canProduction) {
        setActiveRunId(null);
        return;
      }
      setCheckingActiveRun(true);
      try {
        const res = await bakingCcpService.getActiveRun();
        const run = res?.run || null;
        if (!cancelled) setActiveRunId(run?.id ?? null);
      } catch (e) {
        if (!cancelled) setActiveRunId(null);
      } finally {
        if (!cancelled) setCheckingActiveRun(false);
      }
    };
    fetchActiveRun();
    return () => { cancelled = true; };
  }, [canProduction, location.pathname]);

  useEffect(() => {
    const handler = () => {
      if (!canProduction) return;
      bakingCcpService.getActiveRun()
        .then(res => setActiveRunId(res?.run?.id ?? null))
        .catch(() => setActiveRunId(null));
    };
    window.addEventListener('productionStatusChanged', handler);
    return () => window.removeEventListener('productionStatusChanged', handler);
  }, [canProduction]);

  const livePath = activeRunId ? `/ccp/baking/live/${activeRunId}` : '/ccp/baking/start';

  return { activeRunId, checkingActiveRun, livePath };
}
